import React from 'react';

import PropTypes from 'prop-types';

import { Avatar, Box, Stack } from '@mui/material';

import GreyBox from './GreyBox';
import { TypoPoppBlue, TypoPoppins } from '../../../Components/Typo';

const ProfessionalDetails = ({ professionalDetails, ...rest }) => {
  const details = {
    'Full name': professionalDetails.name,
    'Post Code': professionalDetails.postCode,
    Address: professionalDetails.address,
    Province: professionalDetails.province,
    'Job Title': professionalDetails?.service?.name ?? '',
    'Service location': professionalDetails?.service?.location ?? '',
    'Phone number': professionalDetails.phoneNumber,
    'Service Website or Facebook Link':
      professionalDetails?.service?.serviceLink ?? '',
  };

  return (
    <GreyBox {...rest}>
      <Stack direction='row' gap={2} alignItems='center' flexWrap='wrap'>
        <Avatar
          src={professionalDetails.avatar}
          sx={{ width: '60px', height: '60px' }}
        />
        <Box>
          <TypoPoppBlue variant='h6'>{professionalDetails.name}</TypoPoppBlue>
          <TypoPoppins>{professionalDetails.jobTitle}</TypoPoppins>
        </Box>
        {professionalDetails.completedOrderCount !== null &&
          typeof professionalDetails.completedOrderCount !== 'undefined' && (
            <Box ml='auto'>
              <TypoPoppins>Complete Job</TypoPoppins>
              <TypoPoppins textAlign='right' variant='h6'>
                {professionalDetails.completedOrderCount}
              </TypoPoppins>
            </Box>
          )}
      </Stack>

      <Box
        display='grid'
        gridTemplateColumns={{ sm: 'repeat(2,1fr)' }}
        rowGap={{ md: 1 }}
        columnGap={1}
        px={{ md: 2 }}
        mt={3}
      >
        {Object.entries(details).map(([label, value]) => (
          <React.Fragment key={label}>
            <TypoPoppins fontWeight={500}>{label}</TypoPoppins>
            <TypoPoppins sx={{ wordBreak: 'break-all' }}>{value}</TypoPoppins>
          </React.Fragment>
        ))}
      </Box>
    </GreyBox>
  );
};

ProfessionalDetails.propTypes = {
  professionalDetails: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    postCode: PropTypes.string,
    address: PropTypes.string,
    province: PropTypes.string,
    phoneNumber: PropTypes.string,
    avatar: PropTypes.string,
    completedOrderCount: PropTypes.number,
    service: PropTypes.shape({
      name: PropTypes.string,
      location: PropTypes.string,
      serviceLink: PropTypes.string,
    }),
  }),
};

export default React.memo(ProfessionalDetails);
